import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { registerUser } from "../../api/auth";

import logo from "../../assets/images/logo/logo-full.png";
import bg6 from "../../assets/images/background/bg6.jpg";
import { countries } from "../components/Admin/CommanPage/countries";

function Register(props) {
  const [heartActive, setHeartActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [username, setUsername] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);

  // const dispatch = useDispatch();
  const navigate = useNavigate();

  async function onSignUp(e) {
    e.preventDefault();

    let error = false;
    const errorObj = {};

    if (firstName.trim() === "") {
      errorObj.firstName = "First name is required";
      error = true;
    }
    if (lastName.trim() === "") {
      errorObj.lastName = "Last name is required";
      error = true;
    }
    if (mobile.trim() === "") {
      errorObj.mobile = "Mobile number is required";
      error = true;
    }

    if (email.trim() === "") {
      errorObj.email = "Email is required";
      error = true;
    }
    if (password.trim() === "") {
      errorObj.password = "Password is required";
      error = true;
    }

    setErrors(errorObj);
    if (error) return;

    setLoading(true);

    try {
      const fullMobileNumber = selectedCountry.dial_code + mobile;
      const data = await registerUser({
        firstName,
        lastName,
        email,
        password,
        mobile: fullMobileNumber,
        userType: "user",
      });

      if (data.token) {
        localStorage.setItem("token", data.token);
      }

      navigate("/login");
    } catch (err) {
      console.error("Signup error:", err);
      setErrors({ api: err.message || "Something went wrong during signup." });
    } finally {
      setLoading(false);
    }
  }

  // dispatch(loadingToggleAction(true));
  // dispatch(signupAction(email, password, navigate));

  return (
    <>
      <div className="page-wraper">
        <div className="browse-job login-style3">
          <div
            className="bg-img-fix overflow-hidden"
            style={{ background: "#090b22", height: "100vh" }}
          >
            <div
              className="col-xl-4 col-lg-5 col-md-6 col-sm-12 bg-white"
              style={{
                justifySelf: "center",
                borderRadius: "2rem",
              }}
            >
              <div
                id="mCSB_1"
                className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
              >
                <div
                  id="mCSB_1_container"
                  className="mCSB_container"
                  style={{
                    position: "relative",
                    top: "0",
                    left: "0",
                    dir: "ltr",
                  }}
                >
                  <div className="login-form style-2">
                    <div className="card-body">
                      <div className="logo-header">
                        <Link to="/login" className="logo">
                          <img
                            src={logo}
                            alt=""
                            className="width-230 mCS_img_loaded"
                          />
                        </Link>
                      </div>
                      <nav className="nav nav-tabs border-bottom-0">
                        <div className="tab-content w-100" id="nav-tabContent">
                          <div className="tab-pane active show fade">
                            {props.errorMessage && (
                              <div className="">{props.errorMessage}</div>
                            )}
                            {props.successMessage && (
                              <div className="">{props.successMessage}</div>
                            )}
                            <form className="dz-form py-2" onSubmit={onSignUp}>
                              <h3 className="form-title">Sign Up</h3>
                              <div className="dz-separator-outer m-b5">
                                <div className="dz-separator bg-primary style-liner"></div>
                              </div>
                              <p>Enter your personal details below: </p>
                              {/* <div className="form-group mt-3">
                                  <input
                                    name="dzName"
                                    value={fullName}
                                    required=""
                                    onChange={(e) =>
                                      setFullName(e.target.value)
                                    }
                                    className="form-control"
                                    placeholder="Full Name"
                                    type="text"
                                  />

                                  {errors.fullName && (
                                    <div className="text-danger fs-12">
                                      {errors.fullName}
                                    </div>
                                  )}
                                </div>
                                <div className="form-group mt-3">
                                  <input
                                    name="dzName2"
                                    value={username}
                                    required=""
                                    onChange={(e) =>
                                      setUsername(e.target.value)
                                    }
                                    className="form-control"
                                    placeholder="User Name"
                                    type="text"
                                  />
                                  {errors.username && (
                                    <div className="text-danger fs-12">
                                      {errors.username}
                                    </div>
                                  )}
                                </div> */}

                              <div className="form-group mt-3">
                                <input
                                  value={firstName}
                                  onChange={(e) => setFirstName(e.target.value)}
                                  className="form-control"
                                  placeholder="First Name"
                                  type="text"
                                />
                                {errors.firstName && (
                                  <div className="text-danger fs-12">
                                    {errors.firstName}
                                  </div>
                                )}
                              </div>

                              <div className="form-group mt-3">
                                <input
                                  value={lastName}
                                  onChange={(e) => setLastName(e.target.value)}
                                  className="form-control"
                                  placeholder="Last Name"
                                  type="text"
                                />
                                {errors.lastName && (
                                  <div className="text-danger fs-12">
                                    {errors.lastName}
                                  </div>
                                )}
                              </div>

                              <div className="form-group mt-3 d-flex ">
                                <select
                                  className="form-select form-select-sm me-2 flex-shrink-0"
                                  style={{
                                    maxWidth: "110px",
                                    minWidth: "80px",
                                  }}
                                  value={selectedCountry.code}
                                  onChange={(e) =>
                                    setSelectedCountry(
                                      countries.find(
                                        (c) => c.code === e.target.value
                                      )
                                    )
                                  }
                                >
                                  {countries.map((country) => (
                                    <option
                                      key={country.code}
                                      value={country.code}
                                    >
                                      {country.emoji} {country.dial_code}
                                    </option>
                                  ))}
                                </select>

                                <input
                                  value={mobile}
                                  onChange={(e) => setMobile(e.target.value)}
                                  className="form-control"
                                  placeholder="Mobile Number"
                                  type="tel"
                                />
                              </div>
                              {errors.mobile && (
                                <div className="text-danger fs-12">
                                  {errors.mobile}
                                </div>
                              )}

                              <div className="form-group mt-3">
                                <input
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  className="form-control"
                                  placeholder="hello@example.com"
                                />
                                {errors.email && (
                                  <div className="text-danger fs-12">
                                    {errors.email}
                                  </div>
                                )}
                              </div>
                              <div className="form-group mt-3">
                                <input
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  className="form-control"
                                  placeholder="passowrd"
                                />
                                {errors.password && (
                                  <div className="text-danger fs-12">
                                    {errors.password}
                                  </div>
                                )}
                              </div>
                              <div className="mb-3 mt-3">
                                <span className="form-check float-start me-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input mt-0"
                                    id="check2"
                                    name="example1"
                                  />
                                  <label
                                    className="form-check-label d-unset"
                                    htmlFor="check2"
                                  >
                                    I agree to the
                                  </label>
                                </span>
                                <label>
                                  <Link to={"#"}>Terms of Service </Link>&amp;{" "}
                                  <Link to={"#"}>Privacy Policy</Link>
                                </label>
                              </div>
                              <div className="form-group clearfix text-left">
                                <NavLink
                                  to="/login"
                                  className="btn btn-primary outline gray"
                                  type="button"
                                >
                                  Back
                                </NavLink>
                                <button
                                  type="submit"
                                  className="btn btn-primary float-end"
                                >
                                  Submit
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </nav>
                    </div>
                    <div className="card-footer">
                      <div className=" bottom-footer clearfix m-t10 m-b20 row text-center">
                        <div className="col-lg-12 text-center">
                          <span>
                            {" "}
                            © Copyright by
                            <span
                              className={`heart ${
                                heartActive ? "" : "heart-blast"
                              }`}
                              onClick={() => setHeartActive(!heartActive)}
                            ></span>
                            <a href="/" rel="noreferrer" target="_blank">
                              {" "}
                              PINANCE{" "}
                            </a>{" "}
                            All rights reserved.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
